export default __webpack_public_path__ + "static/media/PoliceClearanceSigned.cbc88c5c.pdf";